import { defineComponent as _defineComponent } from 'vue'
import FiltersListSection from '@ve/components/searchFilters/filterList/desktop/FiltersListSection.vue';
    import useBudgetFilter from '../lib/useBudgetFilter';
    import PriceInputs from './PriceInputs.vue';
    import PriceSelectors from './PriceSelectors.vue';
    import TouristGroup from './TouristGroup.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DesktopBudgetFilter',
  props: {
    prices: null
  },
  setup(__props: any) {

const props = __props as {
        prices: number[];
    }

    

    const { maxPrice, minPrice } = useBudgetFilter(props);


return { __sfc: true,props, maxPrice, minPrice, FiltersListSection, PriceInputs, PriceSelectors, TouristGroup }
}

})